import { i18n, inject, observer, pr, React, RouteComponentProps, ui, theme } from "aaa";
import { MessageScreen } from "components/common/MessageScreen";
import externalInterfaceStore, { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { PocketsStore } from "./PocketsStore";

interface IProps {
    externalInterfaceStore: ExternalInterfaceStore;
    store: PocketsStore;
}

@inject("externalInterfaceStore")
@observer
export class PocketsSuccess extends React.Component<IProps & i18n.InjectedIntlProps & RouteComponentProps<{}>, {}> {
    render() {
        const infoBoxColor = externalInterfaceStore.isGeorgeApp ? "white" : undefined;

        return (
            <MessageScreen
                icon={pr.IconMessageOk}
                useWebVersion
                variant="success"
                title={this.props.store.alreadyActivated ? undefined : ui.__("pockets.success.title")}
                messageComponent={this.props.store.alreadyActivated
                    ? ui.__("pockets.success.message.alreadyActivated")
                    : ui.__("pockets.success.message")
                }
                buttonLabelId="common.backToGeorgeGo"
                onDismiss={() => this.props.externalInterfaceStore.raiseExitSuccess("creditCardPurchase")}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pockets/PocketsSuccess.tsx